export default __webpack_public_path__ + "static/media/pokeball-dark.b8f75280.png";